import { render, staticRenderFns } from "./FormPurchaseBuyer.vue?vue&type=template&id=9b3229e6&"
import script from "./FormPurchaseBuyer.vue?vue&type=script&lang=ts&"
export * from "./FormPurchaseBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports